import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import "../Styles/Dashboard.css";
import Axios from 'axios';
import UserProfileHeader from './MDUserProfileHeader';
import ErrorBoundary from '../Components/ErrorBoundary';
import { toast, ToastContainer } from 'react-toastify';
import MDUserProfileHeader from './MDUserProfileHeader';
//import panelVersions from "../Config/panelVersions.json";

const MDDashboard = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const { mdId } = useParams();

  // If someone hits this page without mdId in the path, bounce home
  useEffect(() => {
    if (!mdId) navigate("/", { replace: true });
  }, [mdId, navigate]);

  // Persist MD so it survives the auth flow
  useEffect(() => {
    if (mdId) localStorage.setItem("md_ref", mdId);
  }, [mdId]);

  useEffect(() => {
    // 1) Must have mdId in URL
    if (!mdId) {
      navigate("/", { replace: true });
      return;
    }

    const email = localStorage.getItem("userEmail") || "";
    const isCustomer = localStorage.getItem("@customer") === "true";

    // 2) Invalid / expired MD session → clean up & go to MD login
    if (!isCustomer || !email) {
      localStorage.removeItem("@customer");
      localStorage.removeItem("userEmail");
      navigate(
        `/${mdId}/login?next=${encodeURIComponent(`/${mdId}/dashboard`)}`,
        { replace: true }
      );
      return;
    }

    // 3) Your existing logic: store IP/location, fetch role, etc.
    Axios.get("https://ipapi.co/json/")
      .then((response) => {
        const ipAddress = response.data.ip;
        const ipLocation = {
          city: response.data.city,
          region: response.data.region,
          country: response.data.country_name,
          latitude: response.data.latitude,
          longitude: response.data.longitude,
        };

        return Axios.post("/store_user_ip_location", {
          email,
          ipAddress,
          ipLocation: JSON.stringify(ipLocation),
        });
      })
      .catch(() => {
        // IP/location failure should not break dashboard
      });

    const fetchRole = () => {
      Axios.post(`/get_user_role`, { email })
        .then((res) => {
          if (res.data?.success) {
            setIsAdmin(!!res.data.is_admin);
          } else {
            toast.error("Failed to retrieve user role");
          }
        })
        .catch(() => {
          toast.error("An error occurred while fetching user role.");
        });
    };

    fetchRole();
  }, [mdId, navigate]);


  // useEffect(() => {
  //   const email = localStorage.getItem('userEmail') || '';

  //   // If no email, leave dashboard cleanly and ask user to log in again.
  //   if (!email) {
  //     // If we're in an MD context, send them to the MD login and back to the MD dashboard
  //     if (mdId) {
  //       navigate(
  //         `/${mdId}/login?next=${encodeURIComponent(`/${mdId}/dashboard`)}`,
  //         { replace: true }
  //       );
  //     } else {
  //       // Fallback: normal VELOX flow
  //       navigate(
  //         `/login?next=${encodeURIComponent('/dashboard')}`,
  //         { replace: true }
  //       );
  //     }
  //     return;
  //   }

  //   // Store IP and location
  //   Axios.get('https://ipapi.co/json/')
  //     .then((response) => {
  //       const ipAddress = response.data.ip;
  //       const ipLocation = {
  //         city: response.data.city,
  //         region: response.data.region,
  //         country: response.data.country_name,
  //         latitude: response.data.latitude,
  //         longitude: response.data.longitude
  //       };

  //       Axios.post(`/store_ip_address`, {
  //         email,
  //         ipAddress,
  //         ipLocation: JSON.stringify(ipLocation)
  //       }).catch((error) => {
  //         console.error("An error occurred while storing IP information.", error);
  //       });
  //     }).catch((error) => {
  //       console.error("Failed to fetch IP information.", error);
  //     });

  //   // Load user role
  //   const fetchRole = () => Axios.post(`/get_user_role`, { email })
  //     .then((response) => {
  //       if (response.data?.success) {
  //         setIsAdmin(!!response.data.is_admin);
  //       } else {
  //         // Retry once after a short delay; if it still fails, show the toast
  //         setTimeout(() => {
  //           Axios.post(`/get_user_role`, { email })
  //             .then((r2) => {
  //               if (r2.data?.success) setIsAdmin(!!r2.data.is_admin);
  //               else toast.error("Failed to retrieve user role");
  //             })
  //             .catch(() => toast.error("An error occurred while fetching user role."));
  //         }, 300);
  //       }
  //     }).catch(() => {
  //       toast.error("An error occurred while fetching user role.");
  //     });
  //   fetchRole();

  //   // Show toast for login success
  //   const loginSuccessMessage = localStorage.getItem('loginSuccessMessage');
  //   if (loginSuccessMessage) {
  //     toast.success(loginSuccessMessage, {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       theme: "light",
  //     });
  //     localStorage.removeItem('loginSuccessMessage');
  //   }
  // }, []);

  return (
    <div className="dashboard">
      <ErrorBoundary>
        <MDUserProfileHeader isAdmin={isAdmin} />
      </ErrorBoundary>
      <ToastContainer position="top-right" />
    </div>
  );
};

export default MDDashboard;
